'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
    ajax = require('./ajax');

var timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    init: function () {
        this.$el = $('#mini-cart');
        this.$content = this.$el.find('.mini-cart-content');

        $('.mini-cart-product').eq(0).find('.mini-cart-toggle').addClass('fa-caret-down');
        $('.mini-cart-product').not(':first').addClass('collapsed')
            .find('.mini-cart-toggle').addClass('fa-caret-right');

        $('.mini-cart-toggle').on('click', function () {
            $(this).toggleClass('fa-caret-down fa-caret-right');
            $(this).closest('.mini-cart-product').toggleClass('collapsed');
        });

        $('.mini-cart-link-cart').on('click touchend', function () {
            if($(this).hasClass('secondary')) {
                tealium.triggerEvent({ event_name: "minicart_viewbag_click" });
            }
            else {
                tealium.triggerEvent({ event_name: "minicart_checkout_click" });
            }
        });

        // events
        this.$el.off('click mouseenter').on('click mouseenter', function () {
            if (this.$content.not(':visible').length) {
            	this.minicartHeightCalc();
                //this.slide();
            }
        }.bind(this));
        
        $('body').off("click.miniCart");
        $('body').on('click.miniCart', '.secondary-header .shopping-bag-sm a, .navigation-cart .shopping-bag-sm a', function () {
            this.minicartHeightCalc();
        }.bind(this));
        $('body').on('mouseover click', '.shopping-bag-sm', function () {
            if (this.$content.is(':visible')) {
            	this.minicartHeightCalc();
                //this.slide();
            }
        }.bind(this));


        this.$content.on('click touch mouseenter', function () {
            timer.clear();
        }).on('mouseleave', function () {
            timer.clear();
            timer.start(1000, this.close.bind(this));
        }.bind(this));
        
        this.$el.on('click touch mouseenter', function () {
            timer.clear();
        }).on('mouseleave', function () {
            timer.clear();
            timer.start(1000, this.close.bind(this));
        }.bind(this));
        
        /*$('.user-info , .customer-service-info').on('click touch mouseenter', function () {
        	timer.clear();
            timer.start(10, this.close.bind(this));
        }.bind(this));*/
        
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html) {

        var $this = this;
        ajax.load({
            url: Urls.minicart,
            callback: function (response) {
                html = response;
                $this.$el.html(html);
                $('.mini-cart-total .mini-cart-content .cart-overlay-html').remove();
                /// util.scrollBrowser(0);
                $this.init();
                //  this.slide();
                //bonusProductsView.loadBonusOption();
                
                if($('.header_fixed ').length == 1) {
                    $('.header_fixed .top-menu-utility .mini-cart-link').addClass('nav-docked').hide().fadeIn(500); 
                }
                if(Number($('.minicart-qty>.total-qty').text()) < Number($('.addtocartoverlay-qty>.total-qty').text())){
                    $('.minicart-qty>.total-qty').text('');
                    $('.minicart-qty>.total-qty').text($('.addtocartoverlay-qty>.total-qty').text());
                }else{
                    $('.addtocartoverlay-qty>.total-qty').text('');
                    $('.addtocartoverlay-qty>.total-qty').text($('.minicart-qty>.total-qty').text());
                }
                if(Number($('.minicart-qty>.total-qty').text()) > 0 && Number($('.minicart-qty>.total-qty').text()) == Number($('.addtocartoverlay-qty>.total-qty').text()) && $('.minicart-qty>.total-qty').hasClass('minicart-quantity')==false){
                    $('.minicart-qty>.total-qty').addClass('minicart-quantity');
                }
                if(Number($('.addtocartoverlay-qty>.total-qty').text())>0 && $('.minicart-qty>.total-qty').closest('.mini-cart-empty').length>0){
                    $('.minicart-qty>.total-qty').closest('.mini-cart-empty').removeClass('mini-cart-empty');
                }
            }
        });

    },
    minicartHeightCalc: function() {
    	if($(".mini-cart-total .mini-cart-content").length > 0 ) {
            $('.mini-cart-total .mini-cart-products').css('height','auto');
            if($('.mini-cart-total .mini-cart-products').outerHeight() >= $('.mini-cart-products-wrapper').first().height()) {
                $('.mini-cart-total .mini-cart-products').slimScroll({
                    height: $('.mini-cart-products-wrapper').first().height(),
                    railVisible: true,
                    color: "#8f8f8f",
                    railColor: "#e9e9e9",
                    distance: '9px',
                    alwaysVisible: true
                });
                $('.mini-cart-total .mini-cart-products').slimScroll({ scrollTo: '0' }); //Defaulting to the top to address scroll bar position issue for SPS items SC-6348
            } else {
                $('.mini-cart-total .mini-cart-products').slimScroll({destroy: true});
            }
    	}
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();
        // show the item
        this.$content.slideDown('slow');
         
        this.$el.find('.mini-cart-link').addClass("minicart_open");
        if( this.$el.find('.mini-cart-link').hasClass("mini-cart-empty") ){
        	this.$el.find('.mini-cart-link').removeClass("minicart_open");
        }
        // after a time out automatically close it
        timer.start(6000, this.close.bind(this));
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function (delay) {
        timer.clear();
        //this.$content.slideUp(delay);
    }
};

module.exports = minicart;
